//Users/sophiawang/2024/summer/webdev/kanbas-react-web-app/src/Kanbas/Courses/Quizzes/client.tsx
// Description: This file defines the client side functions for quizzes.
import axios from "axios";
const REMOTE_SERVER = process.env.REACT_APP_REMOTE_SERVER;
const COURSES_API = `${REMOTE_SERVER}/api/courses`;
const QUIZZES_API = `${REMOTE_SERVER}/api/quizzes`;

// Create a new quiz
export const createQuiz = async (courseId: string, quiz: any) => {
    const response = await axios.post(
        `${COURSES_API}/${courseId}/quizzes`,
        { ...quiz, id: new Date().getTime().toString() }
    );
    return response.data;
};

// Update a quiz
export const updateQuiz = async (quiz: any) => {
    const response = await axios.put(
        `${QUIZZES_API}/${quiz._id}`,
        quiz
    );
    return response.data;
};

// Delete a quiz
export const deleteQuiz = async (quizId: string) => {
    const response = await axios.delete(`${QUIZZES_API}/${quizId}`);
    return response.data;
};

// Find all quizzes for a course
export const findQuizzesForCourse = async (courseId: string) => {
    const response = await axios.get(`${COURSES_API}/${courseId}/quizzes`);
    return response.data;
};

export const findAllQuizzes = async () => {
    const response = await axios.get(QUIZZES_API);
    return response.data;
};
